import styled from 'styled-components/macro';

export const ResendRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
`;
